import React from "react";
import {
  Grid,
} from "@mui/material";
import { format } from "date-fns";

export default function InstanceDataRow (key: string, value: string | number | null, dataFormat: string | null = null) {
  let keyWidth = 3;
  let valueWidth = 3;
  let data = value;
  switch (dataFormat) {
    case "time":
      data = value ? format(new Date(value), "dd MMMM yyyy HH:mm") : "-"
      break;
    case "url":
      // this left here if we want to add link to the URL
      keyWidth = 3;
      valueWidth = 9;
      break;
    case "wide":
      keyWidth = 3;
      valueWidth = 9;
      break;
    default:
      break;
  }
  return (
    <>
      <Grid item xs={keyWidth} sx={{fontWeight: 'bold'}}>
        {key}
      </Grid>
      <Grid item xs={valueWidth}>
        {data}
      </Grid>
    </>
  )
}